import { Box, Typography } from "@mui/material";

const DashboardBox = ({ title, count, color, Muiicon }) => (
    <Box sx={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        borderRadius: "10px",
        backgroundColor: "white",
        width: "250px",
        height: "150px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }}>
        {/* <Box sx={{width:"95%", display:"flex"}}> */}
            {/* <Muiicon sx={{ color: "grey", ml: "10px" }} /> */}
            <Typography color="black">{title}</Typography>
        {/* </Box> */}
        <Typography sx={{ color, fontSize: "3rem", fontWeight: "bold" }}>{count}</Typography>
    </Box>
);
export default DashboardBox;
